import React, { useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '@components/loader/1'
import { Link } from 'gatsby'

const MOCKDATA: RealEstateDataPageComponentData = {
  title: 'Nuestro servicios',
  paragraph: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim expedita natus est ullam a officia quas velit quae.",
  opBannerSpace: true,
  opBanner: [
    {
        id: "1",
        button: {
            link: "/comprar",
            value: "Quiero comprar una propiedad"
        },
        image: "https://cdn.pixabay.com/photo/2017/03/28/12/10/chairs-2181947_1280.jpg"
    },
    {
        id: "2",
        button: {
            link: "/alquilar",
            value: "Quiero alquilar una propiedad"
        },
        image: "https://cdn.pixabay.com/photo/2017/04/10/22/28/residence-2219972_1280.jpg"
    },
    {
        id: "3",
        button: {
            link: "/temporario",
            value: "Quiero alquilar temporariamente una propiedad"
        },
        image: "https://cdn.pixabay.com/photo/2022/02/23/14/50/houses-7030773_1280.jpg"
    }
  ],
}

const OperationBanner = (props: RealEstateDataPageComponentData) => {

  const { isDemo } = props
  const { title, paragraph, opBannerSpace, opBanner } = isDemo ? MOCKDATA : props

  // Loader effect
  const [load, setLoad] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 2000)
  }, [])

  return (
    <section id="operation-banner" className={'opb' + (opBanner?.length === 0 ? ' d-none' : '')}>
        {
            !load ?
            <>
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <h2 className="section-title pb-2 pb-lg-3 text-center">{title}</h2>
                        </Col>
                        { paragraph &&
                            <Col xs={12}>
                                <p className="section-text pb-3 pb-lg-4 text-center">{paragraph}</p>
                            </Col> }
                    </Row>
                </Container>
                <div className="op-wrapper my-4">
                    <Row className="h-100">
                        { opBanner?.map((b,i) => (
                            <Col key={i} xs={12} lg={((opBanner.length > 2) ? 4 : 6)} className={(opBannerSpace ? "px-1" : "px-0")}>
                                <Link to={b.button?.link!} className="op-link w-100 h-100 d-flex justify-content-center align-items-center position-relative">
                                    <img src={b.image} alt={b.button?.value} className="op-img position-absolute w-100 h-100 object-fit-cover z-0"/>
                                    <button className="op-btn btn btn-blue z-1">{b.button?.value}</button>
                                </Link>
                            </Col>))}
                    </Row>
                </div>
            </>
            : <Loader />
        }
    </section>
  )
}

export default OperationBanner
